// extracted by mini-css-extract-plugin
export default {"bestBox":"Flight_bestBox__sAlxm","span":"Flight_span__Na-Xf"};